export const customCardHeadStyle = { border: 0, color: 'grey' };
